import { GetterTree } from 'vuex'
import { PowerIncreasePackagesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<PowerIncreasePackagesState, RootState> = {
}
